import { Component, Input } from '@angular/core';

export type CalloutType = 'info' | 'warning';

/** A bordered, icon-led message box for surfacing a single important line of text (e.g. inside the Okta sign-in card). */
@Component({
  selector: 'of-callout',
  templateUrl: './callout.component.html',
  styleUrls: ['./callout.component.scss'],
  standalone: false,
})
export class CalloutComponent {
  /** Controls the icon and color scheme of the callout. */
  @Input() type: CalloutType = 'info';
  /** The message to display. */
  @Input() message = '';

  get icon(): string {
    return this.type === 'warning' ? 'warning' : 'info';
  }
}
